<template>
  <div>
    <PrimeDialog
      v-model:visible="visible"
      v-bind="attrs"
      :style="{ width: '50vw' }"
      :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :header="`Edit ${meta.data.Table.TableNameUser}`"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
        <div class="col-span-full mb-1 text-2xl">
          {{ meta.data.Table.TableNameUser }}
        </div>
        <div class="col-span-full flex flex-row gap-2">
          <PrimeButton
            label="Select All"
            icon="pi pi-circle-fill"
            @click="selectAll"
            :disabled="
              selectedFields.length ===
              props.meta.enabledCreateFormColumns.length
            "
          />
          <PrimeButton
            label="De-select All"
            icon="pi pi-circle"
            @click="deselectAll"
            :disabled="selectedFields.length === 0"
          />
        </div>
        <div
          v-for="col of props.meta.enabledCreateFormColumns"
          :key="col.ColumnName"
          class="flex flex-row gap-1"
        >
          <PrimeCheckbox
            v-model="selectedFields"
            :inputId="col.ColumnName"
            name="column"
            :value="col"
          />
          <label :for="col.ColumnName">{{ col.ColumnLabel }}</label>
        </div>
      </div>
      <template #footer>
        <PrimeButton
          @click="
            () => {
              emits('copy', {
                record: props.data,
                copyFields: selectedFieldsQuery,
              });
              visible = false;
            }
          "
          :label="`Copy ${meta.data.Table.TableNameUser}`"
          icon="pi pi-copy"
        />
      </template>
    </PrimeDialog>
    <slot :toggle="toggle"></slot>
  </div>
</template>

<script setup lang="ts">
import type { IMetaColumn, IMetaComputed } from "~/scad-shared/types/scad";

const attrs = useAttrs();

const slots = defineSlots<{
  default(props: { toggle(): void }): any;
}>();

const props = withDefaults(
  defineProps<{
    data?: { [key: string]: any };
    meta: IMetaComputed;
  }>(),
  {
    loading: false,
    data: () => ({}),
  }
);

// Dialog config
const visible = defineModel<boolean>("visible", {
  default: false,
});

const emits = defineEmits<{
  copy: [event: { record: Indexable; copyFields: any }];
}>();

function toggle() {
  visible.value = !visible.value;
}

// Copy data
const selectedFields = ref<IMetaColumn[]>([]);
const selectedFieldsQuery = computed<string[]>(() => {
  const fields: string[] = [];

  selectedFields.value.forEach((selectedField) => {
    fields.push(selectedField.ColumnNamePc);
  });

  return fields;
});

function selectAll() {
  selectedFields.value = props.meta.enabledCreateFormColumns;
}
function deselectAll() {
  selectedFields.value = [];
}
</script>

<style scoped></style>
